import { render } from "./subheader-documents.vue?vue&type=template&id=6f0ff2a4"
import script from "./subheader-documents.vue?vue&type=script&lang=js"
export * from "./subheader-documents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__